(function(){
  var root = document.querySelector('[data-btg-offers]');
  if(!root) return;

  async function refreshCartUI(){
    try{
      var res = await fetch('/cart.js',{
        headers:{ 'Accept':'application/json' },
        credentials:'same-origin'
      });

      if(!res.ok) return;

      var cart = await res.json();

      document.dispatchEvent(new CustomEvent('cart:updated',{
        bubbles:true,
        detail:{ cart:cart }
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{
        bubbles:true,
        detail:{ cart:cart }
      }));

      document.dispatchEvent(new CustomEvent('cart:refresh',{
        bubbles:true,
        detail:{ cart:cart }
      }));

      if(window.MinimogEvents && typeof window.MinimogEvents.publish === 'function'){
        window.MinimogEvents.publish('cart:updated', cart);
        window.MinimogEvents.publish('cart:refresh', cart);
      }
    }catch(e){}
  }

  root.querySelectorAll('[data-btg-atc-form]').forEach(function(form){
    form.addEventListener('submit', async function(e){
      e.preventDefault();
      var btn = form.querySelector('[data-btg-atc-btn]');
      var input = form.querySelector('[data-btg-variant-id]');
      if(!btn || !input) return;
      var variantId = parseInt(input.value, 10);
      if(!variantId || Number.isNaN(variantId)) return;
      if(btn.disabled) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      try{
        var body = new URLSearchParams();
        body.append('id', String(variantId));
        body.append('quantity','1');
        body.append('properties[_source]', 'better-together');
        var res = await fetch('/cart/add.js',{
          method:'POST',
          headers:{
            'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8',
            'Accept':'application/json'
          },
          credentials:'same-origin',
          body:body.toString()
        });
        if(!res.ok) throw new Error('Add failed');
        btn.textContent = 'Added';
        await refreshCartUI();
        setTimeout(function(){
          btn.textContent = 'Add';
          btn.disabled = false;
        }, 900);
      }catch(err){
        btn.textContent = 'Error';
        setTimeout(function(){
          btn.textContent = 'Add';
          btn.disabled = false;
        }, 1100);
      }
    });
  });
})();
